// extracted by mini-css-extract-plugin
module.exports = {"skeleton-loader":"skeleton-loader_skeleton-loader__ETOQl","skeleton-loading":"skeleton-loader_skeleton-loading__4KNmP"};